export var detailsBtn = {
  padding: '0.6em',
  '& > i': {
    margin: 0
  }
};